// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import MarkdownController from "./markdown_controller";

import("./application/administration/emails/deliveries_controller.js").then(module => {
    application.register("application-administration-emails-deliveries", module.default);
});

application.register("markdown", MarkdownController);
